// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input {
  flex: 1;
}

::ng-deep ion-input.Input {
  --highlight-color-valid: var(--smartflip-blue, black);
  --highlight-color: var(--smartflip-blue, black);
  --color: var(--smartflip-blue, black);
}
::ng-deep ion-input.Input label {
  --color: yellow !important;
}`, "",{"version":3,"sources":["webpack://./libs/features/feat-form-fields/src/lib/input/input.component.scss"],"names":[],"mappings":"AAAA;EACE,OAAA;AACF;;AAGE;EACE,qDAAA;EACA,+CAAA;EACA,qCAAA;AAAJ;AAEI;EACE,0BAAA;AAAN","sourcesContent":[".Input {\n  flex: 1;\n}\n\n::ng-deep {\n  ion-input.Input {\n    --highlight-color-valid: var(--smartflip-blue, black);\n    --highlight-color: var(--smartflip-blue, black);\n    --color: var(--smartflip-blue, black);\n\n    label {\n      --color: yellow !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
